import { render, staticRenderFns } from "./MyBillLadingListItem.vue?vue&type=template&id=2b88bd48&scoped=true&"
import script from "./MyBillLadingListItem.vue?vue&type=script&lang=js&"
export * from "./MyBillLadingListItem.vue?vue&type=script&lang=js&"
import style0 from "./MyBillLadingListItem.vue?vue&type=style&index=0&id=2b88bd48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88bd48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b88bd48')) {
      api.createRecord('2b88bd48', component.options)
    } else {
      api.reload('2b88bd48', component.options)
    }
    module.hot.accept("./MyBillLadingListItem.vue?vue&type=template&id=2b88bd48&scoped=true&", function () {
      api.rerender('2b88bd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyBillLading/MyBillLadingListItem.vue"
export default component.exports